import { render, staticRenderFns } from "./dash-history.vue?vue&type=template&id=25bae8ee&"
import script from "./dash-history.vue?vue&type=script&lang=js&"
export * from "./dash-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports